import Axios from 'axios';

const axios = Axios.create({
  // baseURL: 'http://129.226.170.45:8301',
  baseURL: 'https://test.cyclostrat.org',
  timeout: 200000, // 请求超时 20s
});

// 前置拦截器（发起请求之前的拦截）
axios.interceptors.request.use(
  (request) => {
    /**
     * 根据你的项目实际情况来对 config 做处理
     * 这里对 config 不做任何处理，直接返回
     */

    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 后置拦截器（获取到响应时的拦截）
axios.interceptors.response.use(
  (response) => {
    /**
     * 根据你的项目实际情况来对 response 和 error 做处理
     * 这里对 response 和 error 不做任何处理，直接返回
     */

    return response.data;
  },
  (error) => {
    if (error.response && error.response.data) {
      console.error(`[Axios Error]`, error.response);
    } else {
      //   ElMessage.error(`${error}`)
    }
    return Promise.reject(error);
  }
);

export default axios;
